/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbListCmdbClassRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbListCmdbClassRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbListCmdbClassRequest>): ServiceNowCmdbListCmdbClassRequest {
        let obj = Object.assign(new ServiceNowCmdbListCmdbClassRequest(), model);
        ServiceNowCmdbListCmdbClassRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbListCmdbClassRequest>): ServiceNowCmdbListCmdbClassRequest {
        if (!model) return null;
        return ServiceNowCmdbListCmdbClassRequest.newInstance(<ServiceNowCmdbListCmdbClassRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbListCmdbClassRequest) {
        if (!obj) return;

        models.ServiceNowCmdbListCmdbClassRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbListCmdbClassRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbListCmdbClassRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the Tenant that user has access to
     */
    tenant_id: string;

    /**
     * Id of the ServiceNow Account in Corestack
     */
    cmdb_account_id: string;

}
